import { QueryErrorBoundary } from "~/components/query-error-boundary"
import { SpinnerFallback } from "~/components/spinner-fallback"
import { ChatList } from "./chat-list"
import { Suspense } from "react"

export function Chats() {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<SpinnerFallback />}>
        <ChatList />
      </Suspense>
    </QueryErrorBoundary>
  )
}
